var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceKpIsSideicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.9582C15.4916 18.9582 15.2083 18.6748 15.2083 18.3332V9.1665C15.2083 8.82484 15.4916 8.5415 15.8333 8.5415C16.175 8.5415 16.4583 8.82484 16.4583 9.1665V18.3332C16.4583 18.6748 16.175 18.9582 15.8333 18.9582Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 6.45817C15.4916 6.45817 15.2083 6.17484 15.2083 5.83317V1.6665C15.2083 1.32484 15.4916 1.0415 15.8333 1.0415C16.175 1.0415 16.4583 1.32484 16.4583 1.6665V5.83317C16.4583 6.17484 16.175 6.45817 15.8333 6.45817Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9582C9.65833 18.9582 9.375 18.6748 9.375 18.3332V14.1665C9.375 13.8248 9.65833 13.5415 10 13.5415C10.3417 13.5415 10.625 13.8248 10.625 14.1665V18.3332C10.625 18.6748 10.3417 18.9582 10 18.9582Z",
    fill: "#909AB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4582C9.65833 11.4582 9.375 11.1748 9.375 10.8332V1.6665C9.375 1.32484 9.65833 1.0415 10 1.0415C10.3417 1.0415 10.625 1.32484 10.625 1.6665V10.8332C10.625 11.1748 10.3417 11.4582 10 11.4582Z",
    fill: "#909AB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 18.9582C3.82502 18.9582 3.54169 18.6748 3.54169 18.3332V9.1665C3.54169 8.82484 3.82502 8.5415 4.16669 8.5415C4.50835 8.5415 4.79169 8.82484 4.79169 9.1665V18.3332C4.79169 18.6748 4.50835 18.9582 4.16669 18.9582Z",
    fill: "#909AB4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 6.45817C3.82502 6.45817 3.54169 6.17484 3.54169 5.83317V1.6665C3.54169 1.32484 3.82502 1.0415 4.16669 1.0415C4.50835 1.0415 4.79169 1.32484 4.79169 1.6665V5.83317C4.79169 6.17484 4.50835 6.45817 4.16669 6.45817Z",
    fill: "#909AB4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 9.7915H2.5C2.15833 9.7915 1.875 9.50817 1.875 9.1665C1.875 8.82484 2.15833 8.5415 2.5 8.5415H5.83333C6.175 8.5415 6.45833 8.82484 6.45833 9.1665C6.45833 9.50817 6.175 9.7915 5.83333 9.7915Z",
    fill: "#909AB4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.7915H14.1667C13.825 9.7915 13.5417 9.50817 13.5417 9.1665C13.5417 8.82484 13.825 8.5415 14.1667 8.5415H17.5C17.8417 8.5415 18.125 8.82484 18.125 9.1665C18.125 9.50817 17.8417 9.7915 17.5 9.7915Z",
    fill: "#909AB4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 11.4585H8.33331C7.99165 11.4585 7.70831 11.1752 7.70831 10.8335C7.70831 10.4918 7.99165 10.2085 8.33331 10.2085H11.6666C12.0083 10.2085 12.2916 10.4918 12.2916 10.8335C12.2916 11.1752 12.0083 11.4585 11.6666 11.4585Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceKpIsSideicon);
export default __webpack_public_path__ + "static/media/Maintenance KPIs - side icon.42af48dba1aaa5e34555844374bb7091.svg";
export { ForwardRef as ReactComponent };